

const menu = () => {
    const burger_lines = document.querySelector('.burger-lines');
    const mobile_nav = document.querySelector('.mobile-nav');
    burger_lines.addEventListener('click', function () {
        burger_lines.classList.toggle('is-active');
        mobile_nav.classList.toggle('is-active');
    })
    document.addEventListener('click', (event) => {
        if (!burger_lines.contains(event.target) && !mobile_nav.contains(event.target)) {
            mobile_nav.classList.remove('is-active');
            burger_lines.classList.remove('is-active');
        }
    });
    function getRandomColor() {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    const listItems = document.querySelectorAll('.color-span');

    listItems.forEach((item) => {
        const randomColor = getRandomColor();
        item.style.backgroundColor = randomColor;
    });
}

export default menu;